import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { NavLink } from 'reactstrap';
import { getUrlParam, setUrlParam } from './helpers/HelperFunctions';
export class Tabs extends Component {
    static propTypes = {
        tabs: PropTypes.array,
        tabChangedCallback: PropTypes.func,
        activeTab: PropTypes.string
    };
    constructor(props) {
        super(props);
        let activeTab = this.props.activeTab ? this.props.activeTab.toLowerCase() : getUrlParam(props.name)?.toLowerCase();
        if (!activeTab && this.props.tabs?.length > 0)
            activeTab = this.props.tabs[0].name;
        else if (!isNaN(activeTab)) {
            const tabNumber = parseInt(activeTab);
            if (tabNumber >= 0 && tabNumber < this.props.tabs?.length)
                activeTab = this.props.tabs[tabNumber].name;
        }
        const lazyLoadedTabs = [activeTab];
        this.state = {
            activeTab: activeTab,
            lazyLoadedTabs: lazyLoadedTabs,
            renderedIds: []
        };
        this.setActiveTab = this.setActiveTab.bind(this);
    }
    componentDidUpdate() {
        let { name, activeTab } = this.props;
        if (activeTab) activeTab = activeTab.toLowerCase();
        if (activeTab !== this.state.activeTab) {
            let { lazyLoadedTabs } = this.state;
            if (!lazyLoadedTabs.includes(activeTab))
                lazyLoadedTabs.push(activeTab);
            this.setState({
                activeTab: activeTab,
                lazyLoadedTabs: lazyLoadedTabs
            });
            if (name) setUrlParam(name, activeTab);
        }
    }
    render() {
        const { tabs, name } = this.props;
        const { activeTab, lazyLoadedTabs } = this.state;
        return (
            <>
                <div className="tabsMobile">
                    <ul className="tabs">
                        {tabs.map((item, index) =>
                            <li key={index}
                                className={(item?.name?.toLowerCase() === activeTab || index.toString() === activeTab) ? "active" : ""}
                                style={{ display: item?.hidden === true ? "none" : "" }}
                                onClick={() => this.setActiveTab(name, item?.name?.toLowerCase() ? item.name : index.toString())}>
                                <NavLink>{item.label}</NavLink>
                            </li>
                        )}
                    </ul>
                </div>
                {this.props?.children?.map((item, index) => {
                    const needRender = lazyLoadedTabs.includes(tabs[index]?.name?.toLowerCase());
                    return (<div key={index} style={(tabs[index]?.name?.toLowerCase() === activeTab || index.toString() === activeTab) ? { display: "" } : { display: "none" }}>
                        {needRender && (item.content ? item.content : (item ? item : ""))}
                    </div>);
                }) ?? ""}
            </>
        );
    }
    setActiveTab(name, activeTab) {
        activeTab = activeTab?.toLowerCase();
        let { lazyLoadedTabs } = this.state;
        if (!lazyLoadedTabs.includes(activeTab))
            lazyLoadedTabs.push(activeTab);
        this.setState({
            activeTab: activeTab,
            lazyLoadedTabs: lazyLoadedTabs
        });
        if (name) setUrlParam(name, activeTab);
        if (this.props.tabChangedCallback) {
            this.props.tabChangedCallback(activeTab);
        }
    }
}